module.exports = __webpack_public_path__ + "static/fonts/snow-cba5b14aa9277a6476cd4cb49f6333e8.svg";